// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divHelpPageContainer {
  display: flex;
  justify-content: space-around;
  font-family: Calibri, sans-serif !important;
  padding-bottom: 16px;
  margin-top: 10px;
  width: 100%;
}
/***** Begin Top Section *****/
.divTopHelpSectionTextContainer {
  border-radius: 5px 0 0 5px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  background-color: #0076a8;
  padding: 0 2em;
}
.divTopHelpSectionTextHeader {
  font-size: 2.5em;
  font-weight: bold;
  padding-bottom: 5px;
}
.divTopHelpSectionTextBody {
  font-size: 1.4em;
}
.imgTopHelpSectionImage {
  border-radius: 0 5px 5px 0;
  width: 100%;
  object-fit: fill;
}
/***** End Top Section *****/

/***** Begin Middle Section *****/
.divMiddleHelpSectionRowContainer {
  display: flex;
  background-color: #ffffff;
  padding-top: 1em;
  padding-bottom: 15px;
  border-bottom: 1px solid;
  border-color: #808080;
}
.divMiddleHelpSectionRowItem {
  border-right: 1px solid #808080;
  height: 65px;
  margin: 0 10px;
}
.divMiddleHelpSectionRowText {
  color: #000000;
  font-size: 1em;
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
}
.divMiddleHelpSectionButtonContainer {
  display: flex;
  justify-content: center;
}
.buttonMiddleHelpSectionButton {
  border: 1px solid #0076a8;
  border-radius: 5px;
  background-color: #ffffff;
  color: #0076a8;
  padding: 8px 10px;
}
.buttonMiddleHelpSectionButton:hover {
  background-color: #f7fcff;
}
.buttonMiddleHelpSectionImageContainer {
  display: flex;
  flex-direction: row;
}
.buttonMiddleHelpSectionImage {
  height: 1.5em;
  margin-right: 5px;
  fill: #0076a8;
  stroke: #0076a8;
}
.buttonMiddleHelpSectionText {
  font-size: 1.2em;
}
/***** End Middle Section *****/

/***** Begin Bottom Section *****/
.divBottomHelpSectionHeaderText {
  border-bottom: 1px solid;
  border-color: #808080;
  padding-bottom: 5px;
  padding-top: 20px;
}
.spanBottomHelpSectionHeaderText {
  font-size: 1.35em;
  color: #000000;
  font-weight: bold;
}
.divBottomHelpSectionRowContainer {
  display: flex;
  flex-direction: row;
}
.divBottomHelpButtonContainer {
  display: flex;
  flex-direction: row;
  border: 1px solid;
  border-radius: 5px;
  margin-top: 10px;
  width: 50%;
}
.divBottomHelpLinkContainer {
  display: flex;
  align-items: center;
  height: 92px;
}
.spanBottomHelpButtonImage {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 17%;
  padding: 10px 15px;
  border-radius: 5px 0 0 5px;
}
.aBottomHelpLink {
  background-color: #ffffff;
  color: #000000 !important;
  border-radius: inherit;
  text-decoration: none !important;
  width: 100%;
}
.aBottomHelpLink:hover {
  background-color: #f7fcff;
}
.svgBottomHelpLinkImageManual {
  height: 3.5em;
  stroke: #ffffff;
  fill: #ffffff;
}
.svgBottomHelpLinkImageDemo {
  height: 3.5em;
  stroke: #000000;
  fill: #000000;
}
.svgBottomHelpLinkImageFAQ {
  height: 3.5em;
  stroke: #000000;
  fill: #000000;
}
.linkBottomHelpButtonText {
  font-size: 1em;
  font-weight: bold;
  margin-left: 10px;
}
/***** End Bottom Section *****/
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/help/helppage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;EAC3C,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;AACA,8BAA8B;AAC9B;EACE,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;AACA,4BAA4B;;AAE5B,iCAAiC;AACjC;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA,+BAA+B;;AAE/B,iCAAiC;AACjC;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA,+BAA+B","sourcesContent":[".divHelpPageContainer {\n  display: flex;\n  justify-content: space-around;\n  font-family: Calibri, sans-serif !important;\n  padding-bottom: 16px;\n  margin-top: 10px;\n  width: 100%;\n}\n/***** Begin Top Section *****/\n.divTopHelpSectionTextContainer {\n  border-radius: 5px 0 0 5px;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 50%;\n  background-color: #0076a8;\n  padding: 0 2em;\n}\n.divTopHelpSectionTextHeader {\n  font-size: 2.5em;\n  font-weight: bold;\n  padding-bottom: 5px;\n}\n.divTopHelpSectionTextBody {\n  font-size: 1.4em;\n}\n.imgTopHelpSectionImage {\n  border-radius: 0 5px 5px 0;\n  width: 100%;\n  object-fit: fill;\n}\n/***** End Top Section *****/\n\n/***** Begin Middle Section *****/\n.divMiddleHelpSectionRowContainer {\n  display: flex;\n  background-color: #ffffff;\n  padding-top: 1em;\n  padding-bottom: 15px;\n  border-bottom: 1px solid;\n  border-color: #808080;\n}\n.divMiddleHelpSectionRowItem {\n  border-right: 1px solid #808080;\n  height: 65px;\n  margin: 0 10px;\n}\n.divMiddleHelpSectionRowText {\n  color: #000000;\n  font-size: 1em;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1em;\n}\n.divMiddleHelpSectionButtonContainer {\n  display: flex;\n  justify-content: center;\n}\n.buttonMiddleHelpSectionButton {\n  border: 1px solid #0076a8;\n  border-radius: 5px;\n  background-color: #ffffff;\n  color: #0076a8;\n  padding: 8px 10px;\n}\n.buttonMiddleHelpSectionButton:hover {\n  background-color: #f7fcff;\n}\n.buttonMiddleHelpSectionImageContainer {\n  display: flex;\n  flex-direction: row;\n}\n.buttonMiddleHelpSectionImage {\n  height: 1.5em;\n  margin-right: 5px;\n  fill: #0076a8;\n  stroke: #0076a8;\n}\n.buttonMiddleHelpSectionText {\n  font-size: 1.2em;\n}\n/***** End Middle Section *****/\n\n/***** Begin Bottom Section *****/\n.divBottomHelpSectionHeaderText {\n  border-bottom: 1px solid;\n  border-color: #808080;\n  padding-bottom: 5px;\n  padding-top: 20px;\n}\n.spanBottomHelpSectionHeaderText {\n  font-size: 1.35em;\n  color: #000000;\n  font-weight: bold;\n}\n.divBottomHelpSectionRowContainer {\n  display: flex;\n  flex-direction: row;\n}\n.divBottomHelpButtonContainer {\n  display: flex;\n  flex-direction: row;\n  border: 1px solid;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: 50%;\n}\n.divBottomHelpLinkContainer {\n  display: flex;\n  align-items: center;\n  height: 92px;\n}\n.spanBottomHelpButtonImage {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 17%;\n  padding: 10px 15px;\n  border-radius: 5px 0 0 5px;\n}\n.aBottomHelpLink {\n  background-color: #ffffff;\n  color: #000000 !important;\n  border-radius: inherit;\n  text-decoration: none !important;\n  width: 100%;\n}\n.aBottomHelpLink:hover {\n  background-color: #f7fcff;\n}\n.svgBottomHelpLinkImageManual {\n  height: 3.5em;\n  stroke: #ffffff;\n  fill: #ffffff;\n}\n.svgBottomHelpLinkImageDemo {\n  height: 3.5em;\n  stroke: #000000;\n  fill: #000000;\n}\n.svgBottomHelpLinkImageFAQ {\n  height: 3.5em;\n  stroke: #000000;\n  fill: #000000;\n}\n.linkBottomHelpButtonText {\n  font-size: 1em;\n  font-weight: bold;\n  margin-left: 10px;\n}\n/***** End Bottom Section *****/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
